@if (reached()) {
  <span>
    Der Mindestbestellwert von
    <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="data().total.minimum"></ui-product-prices-formatter>
    <span class="medium">(netto, ohne Pfand) für kostenfreie Lieferungen</span> ist erreicht
  </span>
} @else {
  <span>
    Noch
    <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="data().total.remaining!"></ui-product-prices-formatter>
    <span class="medium">(netto, ohne Pfand)</span> bis der Mindestbestellwert <span class="medium">für kostenfreie Lieferungen</span> erreicht ist
  </span>
}

<span [class.inactive]="data().nonTobacco.status === 'inactive'">
  Food, Frische, TKK und/oder Non-Food
  <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="data().nonTobacco.minimum"></ui-product-prices-formatter>
  (<span class="medium">netto,</span> ohne Pfand)
</span>

<span [class.inactive]="data().tobacco.status === 'inactive'">
  Zigaretten, Zigarren, Tabak, RBA und/oder E-Zigarette
  <ui-product-prices-formatter [showThousandthsPlace]="false" [price]="data().tobacco.minimum"></ui-product-prices-formatter>
</span>
